import { z } from 'zod';
import { DISPLAY_NAME_MAX_LENGTH, DISPLAY_NAME_MIN_LENGTH, DISPLAY_NAME_PATTERN } from './players';
import { isRoomCode, normalizeRoomCode } from './room-code';

export const displayNameSchema = z
  .string()
  .trim()
  .min(DISPLAY_NAME_MIN_LENGTH)
  .max(DISPLAY_NAME_MAX_LENGTH)
  .regex(DISPLAY_NAME_PATTERN);

export const roomCodeSchema = z.string().transform(normalizeRoomCode).refine(isRoomCode);

export const gameIdSchema = z.string().regex(/^[a-z0-9-]{1,40}$/);

export const roomVisibilitySchema = z.enum(['public', 'private']);

export const createRoomRequestSchema = z.object({
  gameId: gameIdSchema,
  visibility: roomVisibilitySchema.default('public'),
});

export const quickJoinRequestSchema = z.object({
  gameId: gameIdSchema,
});

export const joinRoomRequestSchema = z.object({
  code: roomCodeSchema,
  restore: z.object({ gameId: gameIdSchema, visibility: roomVisibilitySchema }).optional(),
});

export const playerReportRequestSchema = z.object({
  playerId: z.string().min(1).max(64),
});
